const eventPrefix = 'sm360.widgets';

export default {
    GARAGE_ADDED: `${eventPrefix}.garage.added`,
    GARAGE_REMOVED: `${eventPrefix}.garage.removed`,
    FINANCING_CREATED: `${eventPrefix}.financing.created`,
    TRADEIN_CREATED: `${eventPrefix}.tradein.created`,
    DEPOSIT_COMPLETED: `${eventPrefix}.deposit.completed`,
    TRADEIN_UPDATED: `${eventPrefix}.tradein.updated`,
    SWITCH_TO_TRADEIN_BAR: 'switchToTradeInBar',
};
